import { Building2, FileText, MessageCircle, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const TrustBullets = () => {
  const { t } = useTranslation('homepage');

  const bullets = [
    {
      icon: Building2,
      label: t('trust.localLabel', 'Hong Kong–focused'),
      description: t('trust.localDesc', 'Only local providers'),
    },
    {
      icon: MessageCircle,
      label: t('trust.whatsappLabel', 'WhatsApp-first'),
      description: t('trust.whatsappDesc', 'Message directly'),
    },
    {
      icon: FileText,
      label: t('trust.profilesLabel', 'Clear provider profiles'),
      description: t('trust.profilesDesc', 'Useful details before you click'),
    },
    {
      icon: ShieldCheck,
      label: t('trust.verificationLabel', 'Verification and real reviews'),
      description: t('trust.verificationDesc', 'Trust cues backed by real data'),
    },
  ];

  return (
    <section className="border-b border-brand-cloud bg-brand-mist py-6 md:py-7">
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-4 md:flex-row md:flex-wrap md:items-start md:justify-between md:gap-6">
          {bullets.map((bullet) => {
            const Icon = bullet.icon;
            return (
              <div
                key={bullet.label}
                className="flex min-w-0 flex-1 items-start gap-3 md:max-w-[23%]"
              >
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-slate" strokeWidth={1.75} />
                <div>
                  <p className="font-heading text-sm font-semibold text-brand-ink">{bullet.label}</p>
                  <p className="mt-1 text-sm text-brand-slate">{bullet.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBullets;
